import React from "react";
import { FaAddressBook } from "react-icons/fa";
import { BsFillPhoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { Ri24HoursFill } from "react-icons/ri";

function ContactAddress({ t }) {
  return (
    <>
      <div className="connectSec">
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <div className="feature-box text-center">
              <div className="feature-box-content">
                <BsFillPhoneFill />
                <h4>{t("Phone Number")}</h4>
                <p>
                  <a href="tel:+966565722871">+966565722871</a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="feature-box text-center">
              <div className="feature-box-content">
                <MdEmail />
                <h4>{t("E-mail Address")}</h4>

                <p>
                  <a href="mailto:info@ggas.com.sa">info@ggas.com.sa</a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-12 col-md-12">
            <div className="feature-box text-center">
              <div className="feature-box-content">
                <FaAddressBook />
                <h4>{t("Address")}</h4>
                <p>
                  RURB 7547, Salman Ibn Amrou Street , Al Rimal District, Riyadh, KSA
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactAddress;
